export default {
    getInvoiceList: (state) => {
        return state.invoiceList;
    },
    getInvoiceListCount: (state) => {
        return state.invoiceListCount;
    },
    getInvoiceMainFilter: (state) => {
        return state.invoiceFilter.main_filter;
    },
    getInvoiceFilterFields: (state) => {
        return state.invoiceFilter.fields;
    },
}
